enum ActionTypes {
  setGeolocation = 'SET_GEOLOCATION',
  setQueryParams = 'SET_QUERY_PARAMS',
  setReferrer = 'SET_REFERRER',
  setUserId = 'SET_USER_ID'
}

export default ActionTypes;
